import { ReportListItemData } from './report-base';

export class TeamRegistrationReportUserListData extends ReportListItemData {
  teamName: string;
  feeName: string;
  clubProgramFeeID: number;
  teamID: number;

  get exportData() {
    return {
      UserID: this.userID,
      'First Name': this.firstName,
      'Last Name': this.lastName,
      'DOB': new Date(this.dob).toISOString().slice(0, 10),
      'Gender': this.gender,
      'Team ID': this.teamID,
      'Team Name': this.teamName,
      'Fee Name': this.feeName,
    };
  }
}

export class TeamRegistrationReport {
  totalNumberOfFemalePlayers: number;
  totalNumberOfMalePlayers: number;
  list: TeamRegistrationReportUserListData[];

  constructor(data: any = {}) {
    this.totalNumberOfFemalePlayers = +data.totalNumberOfFemalePlayers;
    this.totalNumberOfMalePlayers = +data.totalNumberOfMalePlayers;
    this.list = data.teamRegistrationReportUserList ?
      data.teamRegistrationReportUserList.map(l => new TeamRegistrationReportUserListData(l)) : [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/reports/team-registration-report.ts